/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetMCPSetupDocsSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetMCPSetupDocsSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetMCPSetupDocsSecurity = {
  option1?: GetMCPSetupDocsSecurityOption1 | undefined;
  option2?: GetMCPSetupDocsSecurityOption2 | undefined;
};

export type GetMCPSetupDocsRequest = {
  /**
   * URL of the upstream MCP server endpoint
   */
  serverUrl?: string | undefined;
  /**
   * Registry specifier for the server, as returned by listCatalog (e.g., 'io.example/server')
   */
  registrySpecifier?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetMCPSetupDocsSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetMCPSetupDocsSecurityOption1$outboundSchema: z.ZodMiniType<
  GetMCPSetupDocsSecurityOption1$Outbound,
  GetMCPSetupDocsSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getMCPSetupDocsSecurityOption1ToJSON(
  getMCPSetupDocsSecurityOption1: GetMCPSetupDocsSecurityOption1,
): string {
  return JSON.stringify(
    GetMCPSetupDocsSecurityOption1$outboundSchema.parse(
      getMCPSetupDocsSecurityOption1,
    ),
  );
}

/** @internal */
export type GetMCPSetupDocsSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetMCPSetupDocsSecurityOption2$outboundSchema: z.ZodMiniType<
  GetMCPSetupDocsSecurityOption2$Outbound,
  GetMCPSetupDocsSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getMCPSetupDocsSecurityOption2ToJSON(
  getMCPSetupDocsSecurityOption2: GetMCPSetupDocsSecurityOption2,
): string {
  return JSON.stringify(
    GetMCPSetupDocsSecurityOption2$outboundSchema.parse(
      getMCPSetupDocsSecurityOption2,
    ),
  );
}

/** @internal */
export type GetMCPSetupDocsSecurity$Outbound = {
  Option1?: GetMCPSetupDocsSecurityOption1$Outbound | undefined;
  Option2?: GetMCPSetupDocsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetMCPSetupDocsSecurity$outboundSchema: z.ZodMiniType<
  GetMCPSetupDocsSecurity$Outbound,
  GetMCPSetupDocsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetMCPSetupDocsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetMCPSetupDocsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getMCPSetupDocsSecurityToJSON(
  getMCPSetupDocsSecurity: GetMCPSetupDocsSecurity,
): string {
  return JSON.stringify(
    GetMCPSetupDocsSecurity$outboundSchema.parse(getMCPSetupDocsSecurity),
  );
}

/** @internal */
export type GetMCPSetupDocsRequest$Outbound = {
  server_url?: string | undefined;
  registry_specifier?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetMCPSetupDocsRequest$outboundSchema: z.ZodMiniType<
  GetMCPSetupDocsRequest$Outbound,
  GetMCPSetupDocsRequest
> = z.pipe(
  z.object({
    serverUrl: z.optional(z.string()),
    registrySpecifier: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      serverUrl: "server_url",
      registrySpecifier: "registry_specifier",
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function getMCPSetupDocsRequestToJSON(
  getMCPSetupDocsRequest: GetMCPSetupDocsRequest,
): string {
  return JSON.stringify(
    GetMCPSetupDocsRequest$outboundSchema.parse(getMCPSetupDocsRequest),
  );
}
